import NonCriticalError from '@/errors/NonCriticalError.js';

class NotFoundError extends NonCriticalError {
}

export default NotFoundError;
